import { create } from "zustand";
import { persist } from "zustand/middleware";

interface TenantSearchFilterState {
  initializedTenants: string[];
  markInitialized: (tenantId: string) => void;
  isInitialized: (tenantId: string) => boolean;
}

const useTenantSearchFilterStore = create<TenantSearchFilterState>()(
  persist(
    (set, get) => ({
      initializedTenants: [],
      markInitialized: (tenantId: string) =>
        set((state) => {
          if (state.initializedTenants.includes(tenantId)) {
            return state;
          }
          return {
            initializedTenants: [...state.initializedTenants, tenantId],
          };
        }),
      isInitialized: (tenantId: string) =>
        get().initializedTenants.includes(tenantId),
    }),
    {
      name: "tenant-search-filter-state",
    }
  )
);

export default useTenantSearchFilterStore;
